<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Quản lý nhãn&nbsp;</span><breadcrumbs [items]="breadcrumbs"></breadcrumbs></div>
    <div class="btn-option flex">
      <page-btn-option-extend [buttonList]="pageOptBtn">
      </page-btn-option-extend>
    </div>
  </div>
  <div #pageSearch>
    <dynamic-form-expand 
      (onSearch)="search($event)" 
      [fields]="formFeildItems"
      [isCollapseBtn]="true"
      [isClearBtn]="true"
      [numberCollapse]="1"
      (onCollape)="toggleCollapse()"
      [value]="formFeildItems"
    >
    </dynamic-form-expand>  
  </div>
  <table-basic [options]="options" [data]="dataTable"
    (pageIndexEvent)="pageIndexEvent($event)"
    (pageSizeEvent)="pageSizeEvent($event)"
    (listCheckedId)="hanlderCheckedId($event)"
    (edit)="openEditTag($event)"
    (delete)="openDeleteTag($event)"
  >
  </table-basic>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>